import React, { useState } from 'react';
import { Modal as UIModal, RichText } from '@shopee/chatbot-ui';
import { getButtonAction } from '@/utils/getButtonData';
import { ButtonGroupProps } from '@shopee/chatbot-ui/lib/components/ButtonGroup';
import { observer, inject } from 'mobx-react';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { INPUT_TYPE, TRACKING_MSG_TYPE } from '@/utils/constants';
import { TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/tracking/constants';
import { ChatbotUIBasicProps } from '@/types/common';
import { isBank } from '@/config/core';

export type ModalProps = {
  taskbotInfo: any;
  title: string;
  content: string;
  jumpNodeMap: Record<string, unknown> | null;
  buttons: {
    button_id: string;
    button_text: string;
    action: {
      action_type: number;
      task_bot_action: any;
    };
  }[];
} & ChatbotUIBasicProps;

const Modal: React.FC<ModalProps> = (props) => {
  //  TODO: 把 active 拿出去
  const [active, setActive] = useState(true);
  const footer = {
    layout: 'horizontal',
    buttons: props.buttons.map((btn, index) => {
      const actionFunc = getButtonAction(btn.action.action_type);
      return {
        text: btn.button_text,
        type: isBank() ? (index === 0 ? 'primary-outlined' : index === 1 ? 'primary' : 'default') : 'default',
        onClick: () => setActive(false),
        action: {
          ...btn.action,
          func: actionFunc,
          info: props,
          nextParams: {
            message_text: btn.button_text,
            input_type: INPUT_TYPE.BUTTON,
            session_id: props.initStore.sessionId,
            dialogue_id: props.dialogueId,
            thread_node_id: props.threadNodeId,
            thread_id: props.threadId,
            thread_id_v2: props.threadIdV2,
            round_id: props.roundId,
            is_bypass: false,
            message_extra: { task_bot_action: Object.assign({ task_bot_info: props.taskbotInfo }, btn.action.task_bot_action) },
          },
        },
        trackingData: {
          trackingsection: TRACKING_SECTION[TRACKING_TYPE.STANDARDIZE_BUTTON],
          trackingtarget: TRACKING_TARGET[TRACKING_TYPE.STANDARDIZE_BUTTON],
          trackingdataBasic: {
            node_point_id: props.nodePointId,
            kb_bot_id: props.kbBotId,
            tf_node_id: props.tfNodeId,
            tf_case_id: props.tfCaseId,
            chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
            chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
            if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
            taskbot_id: props.taskbotInfo?.task_bot_id,
            taskflow_id: props.taskbotInfo?.flow_id,
          },
          trackingdataTarget: {
            button_text: btn.button_text,
            button_id: btn.button_id,
            button_type: btn.action?.action_type?.toString?.(),
          },
        },
      };
    }),
  };

  const jumpNodeMap = Object.fromEntries(
    Object.entries(props.jumpNodeMap || {}).map((item) => [
      item[0],
      {
        nextParams: {
          input_type: INPUT_TYPE.BUTTON,
          session_id: props.initStore.sessionId,
          dialogue_id: props.dialogueId,
          thread_node_id: props.threadNodeId,
          thread_id: props.threadId,
          thread_id_v2: props.threadIdV2,
          round_id: props.roundId,
          is_bypass: (item[1] as { is_bypass: boolean })?.is_bypass || false,
          message_extra: { task_bot_action: Object.assign({}, item[1], { button_id: item[0] }) },
        },
      },
    ]),
  );

  return (
    <UIModal
      className={`${isBank() ? 'chatbot-bank-modal' : ''}`}
      active={active}
      title={props.title}
      footer={footer as ButtonGroupProps}
      onClose={() => setActive(false)}
    >
      <RichText content={props.content} jumpNodeMap={jumpNodeMap} />
    </UIModal>
  );
};

export default inject(getChildInject('initStore'))(observer(Modal));
